import { CheckCircle2, Circle } from 'lucide-react'
import { cn } from '@/utils/cn'

type Props = {
  telefoneOk: boolean
  nomeOk: boolean
  empresaOk: boolean
  whatsappOnlyPhone: boolean
}

function Step({
  done,
  label,
  pending,
}: {
  done: boolean
  label: string
  pending?: boolean
}) {
  const Icon = done ? CheckCircle2 : Circle
  return (
    <li className='flex items-center gap-2 text-xs'>
      <Icon
        size={14}
        className={cn(
          'shrink-0',
          done ? 'text-emerald-500' : pending ? 'text-amber-500' : 'text-text-muted',
        )}
      />
      <span
        className={cn(
          done ? 'text-[var(--text-primary)]' : pending ? 'font-medium text-amber-800 dark:text-amber-200' : 'text-text-muted',
        )}
      >
        {label}
      </span>
    </li>
  )
}

export function QrLeadScanGuide({ telefoneOk, nomeOk, empresaOk, whatsappOnlyPhone }: Props) {
  if (!telefoneOk) return null

  return (
    <div className='rounded-xl border border-accent/25 bg-accent/5 px-4 py-3'>
      <p className='text-sm font-semibold text-[var(--text-primary)]'>
        {whatsappOnlyPhone ? 'QR do WhatsApp lido' : 'QR de contato lido'}
      </p>
      <p className='mt-1 text-xs leading-relaxed text-text-muted'>
        {whatsappOnlyPhone
          ? 'O WhatsApp só envia o telefone no QR — o nome não vem automaticamente.'
          : 'Confira os dados e complete o que faltar antes de cadastrar.'}
      </p>
      <ol className='mt-3 space-y-1.5'>
        <Step done={telefoneOk} label='Telefone (do QR)' />
        <Step done={nomeOk} label='Nome do contato' pending={!nomeOk} />
        <Step done={empresaOk} label='Empresa' pending={!empresaOk && nomeOk} />
      </ol>
    </div>
  )
}
